import { render, staticRenderFns } from "./TintometricoFabricante.vue?vue&type=template&id=4fbcbc03"
import script from "./TintometricoFabricante.vue?vue&type=script&lang=js"
export * from "./TintometricoFabricante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports